import { render } from "./registry.vue?vue&type=template&id=4e94ae68"
import script from "./registry.vue?vue&type=script&lang=js"
export * from "./registry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__